var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"id":_vm.id,"type":"email"},domProps:{"value":_vm.email},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }